module.exports = __webpack_public_path__ + "static/media/desert-large-arena.bbaabc08.png";